import {NgModule} from '@angular/core';

import {DateTimeFormatterPipe} from './date-time-formatter.pipe';
import {SafePipe} from './safe.pipe';
import {AcFuncPipe} from './func.pipe';
import {numberToKPipe} from './number-to-k.pipe';
import {IPDisplayPipe} from './ip-display.pipe';

const pipes = [
    DateTimeFormatterPipe,
    SafePipe,
    AcFuncPipe,
    numberToKPipe,
    IPDisplayPipe
];

@NgModule({
    declarations: [...pipes],
    exports: [...pipes],
    providers: [...pipes],
})
export class InfraPipesModule {}

